export default __webpack_public_path__ + "static/media/lion_NORMAL.97c4e2c1.png";